// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Container Style */
.Register_registerContainer__Ny48-,
.Register_loginContainer__l\\+p2K {
  display: flex;
  height: 100vh;
  width: 100%;
}

.Register_logo__L6J0Y {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
}

.Register_formBg__nG8FK {
  flex-grow: 1;
  position: relative;
}

.Register_background__Qw2aV {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

/* Form Styles */
.Register_registerForm__rBbpq,
.Register_checkEmail__9H7bW {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.Register_registerContainer__Ny48- .Register_inputs__En6Rc {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 400px;
}

.Register_registerForm__rBbpq h2 {
  font-size: 55px;
  font-weight: 600;
  line-height: 71.5px;
  color: white;
}

.Register_input__GcvBj {
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  gap: 8px;
  border: 1px solid #ededed;
  color: #ededed;
  background-color: transparent;
  align-items: start;
}

.Register_input__GcvBj input {
  color: #ededed;
  background-color: transparent;
  border: none;
}

/* Button Styles */
.Register_registerBtn__8ZPnz,
.Register_resetPassBtn__14q3Z {
  width: 400px;
  height: 60px;
  border-radius: 8px;
  padding: 0 16px;
  line-height: 24px;
  color: #676c7e;
  border: none;
  cursor: pointer;
  background-color: white;
}

.Register_registerBtn__8ZPnz:disabled {
  background-color: rgb(219, 218, 218);
}

.Register_checkEmail__9H7bW p {
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
  color: white;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/register/Register.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;;EAEE,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;;EAEE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA,kBAAkB;AAClB;;EAEE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":["/* General Container Style */\r\n.registerContainer,\r\n.loginContainer {\r\n  display: flex;\r\n  height: 100vh;\r\n  width: 100%;\r\n}\r\n\r\n.logo {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0 30px;\r\n}\r\n\r\n.formBg {\r\n  flex-grow: 1;\r\n  position: relative;\r\n}\r\n\r\n.background {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  border-top-right-radius: 50px;\r\n  border-bottom-right-radius: 50px;\r\n}\r\n\r\n/* Form Styles */\r\n.registerForm,\r\n.checkEmail {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n\r\n.registerContainer .inputs {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  width: 400px;\r\n}\r\n\r\n.registerForm h2 {\r\n  font-size: 55px;\r\n  font-weight: 600;\r\n  line-height: 71.5px;\r\n  color: white;\r\n}\r\n\r\n.input {\r\n  padding: 8px 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-radius: 12px;\r\n  gap: 8px;\r\n  border: 1px solid #ededed;\r\n  color: #ededed;\r\n  background-color: transparent;\r\n  align-items: start;\r\n}\r\n\r\n.input input {\r\n  color: #ededed;\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n/* Button Styles */\r\n.registerBtn,\r\n.resetPassBtn {\r\n  width: 400px;\r\n  height: 60px;\r\n  border-radius: 8px;\r\n  padding: 0 16px;\r\n  line-height: 24px;\r\n  color: #676c7e;\r\n  border: none;\r\n  cursor: pointer;\r\n  background-color: white;\r\n}\r\n\r\n.registerBtn:disabled {\r\n  background-color: rgb(219, 218, 218);\r\n}\r\n\r\n.checkEmail p {\r\n  line-height: 24px;\r\n  font-size: 16px;\r\n  font-weight: 400;\r\n  color: white;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"registerContainer": `Register_registerContainer__Ny48-`,
	"loginContainer": `Register_loginContainer__l+p2K`,
	"logo": `Register_logo__L6J0Y`,
	"formBg": `Register_formBg__nG8FK`,
	"background": `Register_background__Qw2aV`,
	"registerForm": `Register_registerForm__rBbpq`,
	"checkEmail": `Register_checkEmail__9H7bW`,
	"inputs": `Register_inputs__En6Rc`,
	"input": `Register_input__GcvBj`,
	"registerBtn": `Register_registerBtn__8ZPnz`,
	"resetPassBtn": `Register_resetPassBtn__14q3Z`
};
export default ___CSS_LOADER_EXPORT___;
